import { render, staticRenderFns } from "./ClaimHistoryPanel.vue?vue&type=template&id=267e3255&scoped=true&"
import script from "./ClaimHistoryPanel.vue?vue&type=script&lang=js&"
export * from "./ClaimHistoryPanel.vue?vue&type=script&lang=js&"
import style0 from "./ClaimHistoryPanel.vue?vue&type=style&index=0&id=267e3255&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267e3255",
  null
  
)

export default component.exports